import React, { useContext, useEffect, useRef, useState } from "react";
import LanguageContext from "../utils/Contexts/LanguageContext";
import axiosInstance from "../utils/Requests/axios";
import UserContext from "../utils/Contexts/UserContext";
import toast from "react-hot-toast";

function UpsertList({ selectedList, setListsData, listsData, listEditMode, setListEditMode }) {
  const { t } = useContext(LanguageContext);
  const { userData } = useContext(UserContext);
  const [listName, setListName] = useState("");
  const [showDuplicateError, setShowDuplicateError] = useState(false);
  const inputRef = useRef(null); // Create a reference for the input field

  useEffect(() => {
    if (selectedList && listEditMode) {
      setListName(selectedList?.name);
    } else {
      setListName("");
    }
  }, [selectedList, listEditMode]);

  const handleListUpsert = () => {
    if (!listName || !userData) {
      toast.error(t("Please enter a list name and ensure profile data is loaded."));
      return;
    }

    const requestData = {
      name: listName,
      uuid: userData.uuid,
      type: userData.organizations[0]?.role,
      domainUuid: userData.organizations[0]?.uuid,
    };

    let url = `/users/${userData?.uuid}/preferences/lists`;
    let method = "POST";

    if (listEditMode) {
      url = `/users/${userData?.uuid}/preferences/lists/${selectedList.uuid}`;
      method = "PUT";
    }

    axiosInstance({
      method,
      url,
      data: requestData,
    })
      .then((response) => {
        let tempListsData = [...listsData];
        if (listEditMode) {
          const listItem = tempListsData.find(listItem => listItem.uuid === selectedList.uuid);
          listItem.name = listName;
        } else {
          tempListsData.push({
            name: response?.data?.name,
            type: response?.data?.type,
            uuid: response?.data?.uuid
          });
        }
        setListsData(tempListsData);
        setListEditMode(false);
        setListName("");
        closeModal();
      })
      .catch((error) => {
        if (error.response.status === 409) {
          setShowDuplicateError(true); 
        }
        toast.error(t("There was an error creating the list:"));
      });
  };

  const closeModal = () => {
    const closeButton = document.querySelector('#modal-sm-create-list [data-bs-dismiss="modal"]');
    if (closeButton) {
      closeButton.click(); // Simulate a click on the close button
    } else {
      console.error('Close button not found.');
    }
  };

  useEffect(() => {
    const modal = document.getElementById("modal-sm-create-list");
    const focusInput = () => {
      if (inputRef.current) {
        inputRef.current.focus(); 
      }
    };
    modal.addEventListener("shown.bs.modal", focusInput);
  }, []);

  return (
    <div
      id="modal-sm-create-list"
      className="modal fade"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modal-sm-create-list-title"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-sm modal-dialog-scrollable modal-dialog-centered"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3 className="modal-title" id="modal-sm-create-list-title">
              { listEditMode ? t('Update List') : t('Create a New List') }
            </h3>
          </div>
          <div className="modal-body">
            <p>
              {t("Use this form to")} { listEditMode ? 'update list' : 'create lists' } {t("of your manually selected sites.")}
              {t("You'll then be able to focus solely on the sites you prefer.")}
            </p>
            <div className="mb-2">
              <input
                type="text"
                id="modal-sm-create-list-input"
                className="form-control"
                placeholder={t("List Name")}
                ref={inputRef}
                value={listName}
                onChange={(e) => {
                  setListName(e.target.value);
                  setShowDuplicateError(false);
                }}
              />
            </div>
            {
              showDuplicateError && (
                <i className="text-danger">{`User list "${listName}" already exists`}</i>
              )
            }
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-white"
              data-bs-dismiss="modal"
              onClick={() => {
                setListEditMode(false);
                setListName("");
              }}
            >
              {t("Close")}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={handleListUpsert}
            >
              { listEditMode ? t('Update') : t('Save') }
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpsertList;
